<script>
import ModalCourseSubjectTestQuestionComponent from '../../features/modals/ModalCourseSubjectTestQuestionComponent';

export default {
  name: 'ModalCourseSubjectTestQuestionView',
  components: {},
  extends: ModalCourseSubjectTestQuestionComponent,
};
</script>

<template>
  <div>
    <el-dialog
      v-model="conf.isVisible"
      title="Pregunta"
      width="55%"
      class="course-subject-modal"
      append-to-body
      :before-close="onCancel"
      :close-on-click-modal="false"
    >
      <el-form
        ref="formData"
        v-loading="conf.isLoading"
        :model="formData"
        :rules="rules"
        status-icon
        :label-position="'top'"
      >
        <fieldset>
          <legend>Información de Pregunta</legend>
          <el-row
            class="row-bg"
            :gutter="20"
          >
            <el-col
              :xs="24"
              :sm="20"
              :md="20"
              :lg="20"
              :xl="20"
            >
              <el-form-item
                label="Descripción"
                prop="description"
              >
                <el-input
                  v-model="formData.description"
                  size="small"
                  class="question_editor"
                />
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="4"
              :md="4"
              :lg="4"
              :xl="4"
            >
              <el-form-item
                label="Orden"
                prop="sort"
              >
                <el-input-number
                  v-model.number="formData.sort"
                  size="small"
                  :disabled="true"
                />
              </el-form-item>
            </el-col>
            <!-- <el-col :span="4">
              <el-form-item label="Duración" prop="duration">
                <el-input v-model="formData.duration" size="small"></el-input>
              </el-form-item>
            </el-col>-->
          </el-row>
          <el-row
            type="flex"
            class="row-bg"
            :gutter="20"
          >
            <el-col :span="24">
              <el-button
                type="primary"
                size="small"
                class="btn-primary"
                icon="el-icon-circle-plus"
                @click="onAddAnswer"
              >
                Agregar Respuesta
              </el-button>
            </el-col>
          </el-row>
          <el-row
            v-loading="isAnswerLoading"
            type="flex"
            class="row-bg"
            :gutter="20"
          >
            <el-col :span="24">
              <br>
              <el-table
                :data="formData.getAnswers()"
                empty-text="No se encontraron resultados."
              >
                <el-table-column
                  label="RESPUESTA"
                  min-width="300"
                >
                  <template #default="scope">
                    <div>
                      <el-input
                        v-model="scope.row.title"
                        size="small"
                        :class="'answer_editor_' + scope.$index"
                      />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="CORRECTO"
                  min-width="120"
                  align="center"
                >
                  <template #default="scope">
                    <div>
                      <el-switch
                        v-model="scope.row.success"
                        active-color="#13ce66"
                        active-text="SI"
                        inactive-text="NO"
                        size="small"
                      />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="OPCIONES"
                  :width="90"
                  align="center"
                  text-align="center"
                >
                  <template #default="scope">
                    <el-button-group>
                      <el-button
                        type="info"
                        size="small"
                        icon="el-icon-delete"
                        @click="
                          onDeleteAnswer(scope.$index)
                        "
                      />
                    </el-button-group>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </fieldset>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            size="small"
            class="btn-cancel"
            @click="onCancel"
          >Cancelar</el-button>
          <el-button
            type="primary"
            :disabled="!onCanSaveOrUpdate()"
            class="btn-primary"
            size="small"
            @click="onSubmitForm('formData')"
          >Aceptar</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
